import type { Schemas } from '@npc/api-client'

/**
 * 「这次接入还会不会再有新东西」——**一份判据，两个地方用。**
 *
 * # 为什么它得单独成一份
 *
 * 这条规则原来有**两份实现**，而且它们分家了：
 *
 * ```
 * queries.ts   refetchInterval    ['awaiting_confirm', 'done', 'failed']   停止轮询
 * index.tsx    finished           ['done', 'failed'] + finished_at         关掉 SSE
 * ```
 *
 * 少的那一档是 `awaiting_confirm`，而**它恰好是最常走到的那一档**：
 * 探测跑完、猜出结果、等他点「就叫这个名字」。轮询在那儿停了，
 * SSE 没停——于是那条流每 3 秒重连一次，**只要他还停在确认卡片上**。
 * 线上量到 140 秒 43 次。
 *
 * 上一版修的是 `failed` 那条路，而**修的时候没发现规则有两份**，
 * 于是「照着改一处」正好改在了走得最少的那一侧。
 * CLAUDE.md §8：**同一条规则有两份实现时，变异验证很可能验的是没改的那一份。**
 *
 * # 它问的不是「接入完了吗」
 *
 * `awaiting_confirm` 在业务上没完（还等他点头），**在事件流上完了**。
 * 两者混成一个词，就是上面那次分家的由来——所以这里的名字是
 * `noMoreEvents`，不是 `finished`。**判据跟着问题走，不跟着状态名走。**
 */
const NO_MORE_EVENTS: readonly Schemas['Onboarding']['status'][] = [
  'awaiting_confirm',
  'done',
  'failed',
]

export function noMoreEvents(onboarding: Schemas['Onboarding'] | undefined): boolean {
  if (!onboarding) return false
  // `finished_at` 是第二个来源：状态机将来加一档终态而这份名单没跟上时，
  // 它还能兜住。**两个都取后端给的，一个都不自己从事件里推**
  return NO_MORE_EVENTS.includes(onboarding.status) || Boolean(onboarding.finished_at)
}
